import { ICubeSchemaMapper } from '../cube-schema-mapper.interface';

export interface IDurationScoresMapper extends ICubeSchemaMapper {}
